
import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons  
import Icon from "@mui/material/Icon";
import Category from "layouts/category";
import SubCategory from "layouts/subCategory";
import Chapter from "layouts/chapter";
import Question from "layouts/question";
import Provider from "layouts/provider";
import Ads from "layouts/ads";
import ads from './assets/images/icons/ads.svg'
import category from './assets/images/icons/category.svg'
import EditProfileDialogue from "layouts/profile/EditProfileDialogue";
import Notification from "layouts/notifications";
import Features from "layouts/features";

const SignOutComponent = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.reload(false)
  // signOut();
  return <SignIn />;
};





const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Category",
    key: "category",
    icon: <img src={category} alt="provider icon" style={{ width: 20, height: 20 }} />,
    route: "/category",
    component: <Category />,
  },

  {
    key: "subcategory",
    route: "/subcategory",
    component: <SubCategory />,
  },
  {
    key: "chapter",
    route: "/chapter",
    component: <Chapter />,
  },
  {
    key: "question",
    route: "/question",
    component: <Question />,
  },
  // {
  //   key: "updateProfile",
  //   route: "/updateProfile",
  //   component: <EditProfileDialogue />,
  // },
  
  {
    type: "collapse",
    name: "Provider",
    key: "provider",
    icon: <img src={ads} alt="provider icon" style={{ width: 30, height: 30 }} />,
    route: "/provider",
    component: <Provider />,
  },
  {
    key: "ads",
    route: "/ads",
    component: <Ads />,
  },
  {
    type: "collapse",
    name: "Notification",
    key: "notification",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notification",
    component: <Notification />,
  },
  {
    type: "collapse",
    name: "Features",
    key: "features",
    icon: <Icon fontSize="small">toggle_on</Icon>,
    route: "/features",
    component: <Features />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },

  {
    // type: "collapse",
    // name: "Sign In",
    key: "sign-in",
    // icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  
  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-out",
    component: <SignOutComponent />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
